import * as Yup from "yup";

export const MaritalStatusSchema = Yup.object().shape({
  name: Yup.string().required("Email is required"),
});
